import React, { FC } from "react";

import useAppStore from "../../Store/AppStore";

const CloseBtn: FC = () => {
  const isModalPopupOpen = useAppStore((state) => state.modalPopupIsOpen);
  const setModalPopupIsOpen = useAppStore((state) => state.setModalPopupIsOpen);

  return (
    <div className="button flex justify-end">
      <button
        className="close-btn"
        onClick={() => setModalPopupIsOpen(!isModalPopupOpen)}
      />
    </div>
  );
};

export default CloseBtn;
